import React, {useState, useEffect} from "react"
import styled from "styled-components"
import _ from "lodash"

import { isValidDate } from "data/lib/dates"
import { isValidNumber } from "data/lib/numbers"

import { DateInput } from "components/table/carousel/inputs"
import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"

const UnitStartContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: baseline;
  margin-top: 20px;
  input[type=radio] {
    margin-right: 5px;
    display: table-cell;
    vertical-align: -webkit-baseline-middle;
  }
  label {
    margin-right: 14px;
  }
`

type UnitStartProps = {
  rowData: object
  field: string|string[]
  persist: (value: UnitStartState, field: string|string[], rowData: object) => void
}

type UnitStartState = {state: string} | {state: string, dateMode: string, date: string}

const UnitStartEdit = (props: UnitStartProps) => {
  const [data, set_data] = useState<UnitStartState>(_.get(props.rowData, props.field))

  useEffect(() => {set_data(_.get(props.rowData, props.field))}, [props.rowData])

  const updateState = newState => {
    if(newState === data.state) return

    let newData
    switch(true) {
      case newState === "analysisStart":
        newData = {state: "analysisStart"}
        break
      case newState === "specifiedDate":
        newData = {state: "specifiedDate", dateMode: "absolute", date: ""}
        break
      case newState === "none":
        newData = {state: "none"}
        break
    }

    set_data(newData)
    props.persist(newData, props.field, props.rowData)
  }

  const updateDate = date => {
    const newData = {state: "specifiedDate", date}
    if(isValidDate(date)) _.set(newData, "dateMode", "absolute")
    else if(isValidNumber(date)) _.set(newData, "dateMode", "relative")
    set_data(newData)
    props.persist(newData, props.field, props.rowData)
  }

  return (
    <div>
      <NoneStateTrashIcon />
      <UnitStartContainer>
        <label>
          <input
            type="radio"
            className="automated"
            name="state"
            value="analysisStart"
            onClick={() => updateState("analysisStart")}
            checked={_.get(data, "state") === "analysisStart"}/>
          Analysis Start
        </label>
        <label>
          <input
            type="radio"
            className="automated"
            name="state"
            value="specifiedDate"
            onClick={() => updateState("specifiedDate")}
            checked={_.get(data, "state") === "specifiedDate"}/>
          Specified Date
        </label>
        { _.get(data, "state") === "specifiedDate" &&
          <DateInput className="automated" field="date" data={data} persist={updateDate} allowRelative withoutDays />
        }
      </UnitStartContainer>
    </div>
  )
}

export default UnitStartEdit
